export default __webpack_public_path__ + "static/media/landing-chat-demo.38814d2f.svg";